import axios from 'axios';

async function ObtenerPrestadores( prmActivos: string = '') {
    
    const url = "https://endpoints.mapsys.com.ar/gestion/obtener_prestadores"
    
    try {

        if (prmActivos === '') {
            const response = await axios.post(url, {
                "usuario": "mpatti",
                "clave": "all2GetHer_!"
            });
            return response.data
        } else {
            const response = await axios.post(url, {
                "usuario": "mpatti",
                "clave": "all2GetHer_!",
                "filtro": prmActivos
            });
            return response.data;
        }
    } catch (error) {
        return error;
    }
};

export default ObtenerPrestadores;